import classnames from 'classnames';
import React from 'react';

const ListItem = ({ item, idx }) => (
	<div className="flex items-center font-body">
		<i
			className={classnames(
				'product-card__delivery-information-icon--rebrand ico text-cta-main mr-1 self-start',
				{
					'ico-delivery text-xl leading-none ': idx === 0,
					'ico-tick text-base w-6 leading-normal': idx > 0,
				}
			)}
		/>
		<li
			className={classnames({
				'product-card__delivery-information-item--rebrand': idx === 0,
			})}
			dangerouslySetInnerHTML={{
				__html: item,
			}}
		/>
	</div>
);

const DeliveryInformation = ({ deliveryInformation, classes }) => {
	if (!deliveryInformation || deliveryInformation.length <= 0) {
		return null;
	}

	return (
		<ul className="my-3 xl:my-4 text-body-xs" style={classes}>
			{deliveryInformation.map((item, idx) => (
				<ListItem key={item} {...{ item, idx }} />
			))}
		</ul>
	);
};

export default DeliveryInformation;
